
import Vue from 'vue';
import { mapActions } from 'vuex';
import Modal from '~/components/common/Modal/Modal.vue';
import EyeSlashIcon from '~/assets/svg/eye-slash.vue.svg';

export default Vue.extend({
  name: 'PublicPortfolioPrivacyModal',
  components: { Modal, EyeSlashIcon },
  methods: {
    ...mapActions('portfolio', ['updatePortfolioConfig']),
    async setPortfolioPublic() {
      this.$analytics.logEvent('public-portfolio__privacy-modal', {
        to: 'make-it-visible',
      });

      await this.updatePortfolioConfig({ configuration: { is_public: true } });
      this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_PRIVACY_MODAL);
    },
    async onTakeMeBackClick() {
      this.$analytics.logEvent('public-portfolio__privacy-modal', {
        to: 'take-me-back',
      });
      await this.$router.push(`?dynamic_modal=${this.$constants.dynamicModals.PUBLIC_PORTFOLIO_SETTINGS_MODAL}`);
    },
  },
});
